@if (type == 'singlepage') {
  <div class="general2">
    @for (page of components; track page) {
      <div class="intro-box">
        @for (element of page.elements; track element) {
          @if (element.type == 'header') {
            <h1 [ngClass]="controller.getClassObject( element, ['header-noned'] )">{{element.value}}</h1>
          }
          @if (element.type == 'p') {
            <p [ngClass]="controller.getClassObject( element, [] )" [innerHTML]="sanitizeHtml(element.value)"></p>
          }
          @if (element.type == 'br') {
            <br />
          }
        }
        <div class="buttons">
          <button class="btn btn-outline-primary btn-outline submit-button" (click)="showAccessibility()">Accessibility</button>
          <button data-testid="intro-start" class="btn btn-outline-primary btn-outline submit-button" (click)="onNext()">START</button>
        </div>
      </div>
    }
  </div>
}



@if (type == 'multipage') {
  <div class="intro-container">
    <h1 [ngClass]="controller.getClassObject( mainHeader, [] )">{{mainHeader.value}}</h1>
    <div [ngClass]="{'card':1, 'card-noned': true}">
      <carousel [page]="page" [itemHeight]="itemHeight" (iveSeenEverything)="onIveSeenEverything()">
        @for (page of components; track page) {
          <ng-container *carouselItem>
            <div [ngClass]="controller.getClassObject(page, ['item'])" >
              @for (element of page.elements; track element) {
                @if (element.type == 'p') {
                  <p [ngClass]="controller.getClassObject( element, [] )" [innerHTML]="sanitizeHtml(element.value)"></p>
                }
                @if (element.type == 'logos') {
                  <div class="logos-container">
                    @for (logo of logos; track logo) {
                      <div class="logo-container logo-small" [style.backgroundImage]="'url(/assets/img/' + (element.value == 'education' ? 'logos' : 'logos-non-education' )  + '/' + logo + '.png)'">
                      </div>
                    }
                  </div>
                }
                @if (element.type == 'stats') {
                  <div [ngClass]=" getStatsClasses(page) " >
                    @for (stat of element.elements; track stat) {
                      <div [ngClass]="controller.getClassObject(stat, ['stat'])">
                        @if (stat.properties.topText) {
                          <p style="margin-bottom:0px;">{{stat.properties.topText}}</p>
                        }
                        <span class="number">{{stat.properties.number}}</span>
                        @if (stat.properties.bottomText) {
                          <p style="margin-top:0px;">{{stat.properties.bottomText}}</p>
                        }
                      </div>
                    }
                  </div>
                }
              }
            </div>
          </ng-container>
        }
      </carousel>
    </div>
    @if (showNext) {
      <div class="buttons">
        <button class="btn btn-outline-primary btn-outline submit-button" (click)="showAccessibility()">Accessibility</button>
        <button data-testid="intro-start-course" class="btn btn-outline-primary btn-outline submit-button" (click)="onStart()">START</button>
      </div>
    }
  </div>
}
